import type { InteractiveQuestionType } from '@genially/document-model';

import type { GeniallyUser } from './GeniallyUser/GeniallyUser';

export class UserQuestion {
  public readonly id: string;

  public readonly type: InteractiveQuestionType;

  public readonly question?: string;

  public readonly answer?: (string | undefined)[];

  public readonly answersSelected?: string[];

  public readonly isCorrect?: boolean;

  public readonly sentDate?: Date;

  public readonly slideId: string;

  public readonly userAlias?: string;

  public readonly geniallyUser?: GeniallyUser;

  public readonly isTimeFinished?: boolean;

  public readonly text?: string;

  private constructor(data: {
    id: string;
    type: InteractiveQuestionType;
    question?: string;
    answer?: (string | undefined)[];
    answersSelected?: string[];
    isCorrect?: boolean;
    isTimeFinished?: boolean;
    sentDate?: Date;
    slideId: string;
    userAlias?: string;
    geniallyUser?: GeniallyUser;
    text?: string;
  }) {
    this.id = data.id;
    this.type = data.type;
    this.question = data.question;
    this.answer = data.answer;
    this.answersSelected = data.answersSelected;
    this.isCorrect = data.isCorrect;
    this.sentDate = data.sentDate;
    this.slideId = data.slideId;
    this.userAlias = data.userAlias;
    this.geniallyUser = data.geniallyUser;
    this.isTimeFinished = data.isTimeFinished;
    this.text = data.text;
  }

  static of(data: {
    id: string;
    type: InteractiveQuestionType;
    question?: string;
    answer?: (string | undefined)[];
    answersSelected?: string[];
    isCorrect?: boolean;
    sentDate?: Date;
    slideId: string;
    userAlias?: string;
    geniallyUser?: GeniallyUser;
    isTimeFinished?: boolean;
    text?: string;
  }): UserQuestion {
    return new UserQuestion(data);
  }

  get nameOrAlias(): string {
    if (this.geniallyUser?.isExistingUser()) {
      return this.geniallyUser.fullName ?? '';
    }

    return this.userAlias ?? '';
  }
}

export type UserQuestionProps = Omit<UserQuestion, 'isUserDeleted' | 'nameOrAlias'>;
